/**
 * This file reads attributes on div that start init- and convert them to props in beforeMount()
 */
import StringFormat from '../helpers/string-format';

export default {
    prop: ['dynamicPropsFromAttr'],
    render(createElement) {
        return createElement(
            'app',
            {
                props: this.dynamicPropsFromAttr,
            },
        );
    },
    beforeMount() {
        this.dynamicPropsFromAttr = {};
        for (let i = 0; i < this.$el.attributes.length; ++i) {
            const attr = this.$el.attributes[i];
            let attrName = attr.name;
            if (attrName.indexOf('init-') >= 0) {
                attrName = StringFormat.kebabToCamel(attrName.replace('init-', ''));
                let attrValue = '';
                try {
                    attrValue = JSON.parse(attr.value);
                } catch {
                    attrValue = attr.value;
                }
                this.dynamicPropsFromAttr[attrName] = attrValue;
            }
        }
    },
};
